/*
 * @Description:
 * @Author: ZY
 * @Date: 2020-12-07 10:30:20
 * @LastEditors: fugang
 * @LastEditTime: 2022-05-11 10:03:56
 */
import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
  RouteRecordRaw
} from "vue-router";
import Layout from "@/layout/Index.vue";

const constantFiles = require.context("./constantModules", true, /\.ts$/);
let constantModules: Array<RouteRecordRaw> = [];
constantFiles.keys().forEach(key => {
  if (key === "./index.ts") return;
  constantModules = constantModules.concat(constantFiles(key).default);
});

const asyncFiles = require.context("./permissionModules", true, /\.ts$/);
let permissionModules: Array<RouteRecordRaw> = [];
asyncFiles.keys().forEach(key => {
  if (key === "./index.ts") return;
  permissionModules = permissionModules.concat(asyncFiles(key).default);
});

export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: "/redirect",
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () =>
          import(
            /* webpackChunkName: "redirect" */ "@/views/redirect/Index.vue"
          )
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ "@/views/dashboard/Index.vue"
          ),
        name: "Dashboard",
        meta: {
          title: "dashboard",
          icon: "#icondashboard",
          affix: true
        }
      }
    ]
  },
  ...constantModules
];

export const asyncRoutes: Array<RouteRecordRaw> = [...permissionModules];

function collectRouteNames(routes: RouteRecordRaw[]): string[] {
  const names: string[] = [];
  routes.forEach(route => {
    if (route.name) {
      names.push(route.name as string);
    }
    if (route.children) {
      names.push(...collectRouteNames(route.children));
    }
  });
  return names;
}

const constantRouteNames = new Set(collectRouteNames(constantRoutes));

let dynamicRouteRemovers: Array<() => void> = [];

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes
});

/** 移除动态添加的路由（Vue Router 4） */
export function resetRouter() {
  dynamicRouteRemovers.forEach(remove => remove());
  dynamicRouteRemovers = [];
  router
    .getRoutes()
    .map(route => route.name)
    .filter(
      (name): name is string | symbol =>
        !!name && !constantRouteNames.has(name as string)
    )
    .forEach(name => {
      router.removeRoute(name);
    });
}

/** 注册动态路由并记录移除函数（支持无 name 的父路由） */
export function addDynamicRoutes(routes: RouteRecordRaw[]) {
  routes.forEach(route => {
    const removeRoute = router.addRoute(route);
    if (typeof removeRoute === "function") {
      dynamicRouteRemovers.push(removeRoute);
    }
  });
}

export default router;
